var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sunken-panel"},[(_vm.topBeveled)?_c('div',{staticClass:"top-edge"}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.bottomBeveled)?_c('div',{staticClass:"bottom-edge"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }